import { FieldSchema } from "../../../Schema";

export const instrumentRUDI: FieldSchema = {
  grid: {
    displayed: true,
    order: 11,
    sortable: false,
  },
  name: "instrumentRUDI",
  display: {
    displayed: true,
  },
  form: { label: "RUDI" },
};
